import Home from "../views/Home.vue";
import Callback from "../views/Auth/Callback.vue";
import Unauthorized from "../views/Auth/Unauthorized.vue";
import OperatorsIndex from "../views/Operators/Index.vue";
import OperatorsCreate from "../views/Operators/Create.vue";
import ProceduresIndex from "../views/Procedures/Index.vue";
import ProceduresCreate from "../views/Procedures/Create.vue";
import ProceduresView from "../views/Procedures/View.vue";
import OperatorsProceduresIndex from "../views/OperatorsProcedures/Index.vue";
import OperatorsProceduresCreate from "../views/OperatorsProcedures/Create.vue";
import GAApi from "../apiGA/GAApi";

const routes = [
    // {
    //   path: "/login",
    //   name: "Login",
    //   component: Login
    // },
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },

    //Operators
    {
        path: "/Operators/Index",
        name: "OperatorsIndex",
        component: OperatorsIndex,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },
    {
        path: "/Operators/Create/:Id?",
        name: "OperatorsCreate",
        component: OperatorsCreate,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },

    //Procedures
    {
        path: "/Procedures/Index",
        name: "ProceduresIndex",
        component: ProceduresIndex,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },
    {
        path: "/Procedures/Create/:Id?",
        name: "ProceduresCreate",
        component: ProceduresCreate,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },
    {
        path: "/Procedures/View/:Id?",
        name: "ProceduresView",
        component: ProceduresView,
        meta: {
            requiresAuth: true
        }
    },

    //OperatorsProcedures
    {
        path: "/OperatorsProcedures/Index",
        name: "OperatorsProceduresIndex",
        component: OperatorsProceduresIndex,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },
    {
        path: "/OperatorsProcedures/Create/:Id?",
        name: "OperatorsProceduresCreate",
        component: OperatorsProceduresCreate,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },

    //Callback
    {
        path: "/callback",
        name: "callback",
        component: Callback,
        meta: {
            requiresAuth: true
            //role: "base",
            //function: "Menu Utente"
        }
    },
    //Unauthorized
    {
        path: "/unauthorized",
        name: "unauthorized",
        beforeEnter(to, from, next) {
            GAApi.GetAccessDeniedPage().then(result => {
                window.location.replace(result.data.Url);
            });
        },
        meta: {
            requiresAuth: false
            //role: "base",
            //function: "Menu Utente"
        }
    }
];

export default routes;
